import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './services/environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {


  constructor(private http: HttpClient,private environmentService: EnvironmentService) {}

  /**
   * Sends a request to the backend API to change the user's password asynchronously.
   * @param userId The user's unique identifier.
   * @param currentPassword The user's current password.
   * @param newPassword The user's new password.
   * @returns A promise with the response from the server.
   */
  async changePassword(
    userId: number,
    currentPassword: string,
    newPassword: string
  ): Promise<any> {
    const requestBody = { userId, currentPassword, newPassword };

    try {
      // Perform the API call and wait for the result
      const apiUrl = `${this.environmentService.activeAppBaseUrl}/api/Account/change-password`;
      const response = await this.http
        .post<any>(apiUrl, requestBody)
        .toPromise();

      return response; // Return the API response
    } catch (error) {
      console.error('Error changing password:', error);
      throw error; // Re-throw the error for handling in the component
    }
  }
  async resetPassword(
    userId: number,
    code: string,
    newPassword: string
  ): Promise<any> {
    const requestBody = { userId, code, newPassword };

    try {
      // Perform the API call and wait for the result
      const apiUrl = `${this.environmentService.activeAppBaseUrl}/api/Account/reset-password`;
      const response = await this.http
        .post<any>(apiUrl, requestBody)
        .toPromise();

      return response; // Return the API response
    } catch (error) {
      console.error('Error reset password:', error);
      throw error; // Re-throw the error for handling in the component
    }
  }
    /**
   * Sends a request to the backend API to change the user's password asynchronously.
   * @param userId The user's unique identifier.
   * @param adminEmail The SuperAdmin's Email address.
   * @param newPassword The user's new password.
   * @returns A promise with the response from the server.
   */
  async changePasswordBySuperAdmin(
    userId: number,
    adminEmail: string,
    newPassword: string
  ): Promise<any> {
    const requestBody = { userId, adminEmail, newPassword };

    try {
      // Perform the API call and wait for the result
      const apiUrl = `${this.environmentService.activeAppBaseUrl}/api/Account/admin-change-user-password`;
      const response = await this.http
        .post<any>(apiUrl, requestBody)
        .toPromise();

      return response; // Return the API response
    } catch (error) {
      console.error('Error changing password:', error);
      throw error; // Re-throw the error for handling in the component
    }
  }
}
